/* tslint:disable:indent */
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { BrowserModule, Title} from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowDown, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { OAuthModule } from 'angular-oauth2-oidc';
import { ToastrModule } from 'ngx-toastr';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './appComponent/app.component';
import { AccessibilityComponent } from './components/accessibility/accessibility.component';
import { ArianeComponent } from './components/ariane/ariane.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeadComponent } from './components/head/head.component';
import { LegalNoticeComponent } from './components/legal-notice/legal-notice.component';
import { MenuComponent } from './components/menu/menu.component';
import { SiteMapComponent } from './components/site-map/site-map.component';
import { TopPageComponent } from './components/top-page/top-page.component';
import { AdministrationModule } from './modules/administration/administration.module';
import { AvisDePubModule } from './modules/avisDePub/avis-de-pub.module';
import { CreerModule } from './modules/avisDePub/creer/creer.module';
import { ErrorHandlerService } from './modules/shared/handlers/errors/error.handler.service';
import { SharedModule } from './modules/shared/shared.module';
import { PreferencesModule } from './modules/avisDePub/preferences-avis-de-pub/preferences.module';
import { InterceptorService } from './authentication/interceptor.service';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { AccessibleToastComponent } from './components/toast/accessible-toast.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    HeadComponent,
    MenuComponent,
    FooterComponent,
    ArianeComponent,
    AccessibilityComponent,
    LegalNoticeComponent,
    TopPageComponent,
    SiteMapComponent,
    AccessibleToastComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatIconModule,
    HttpClientModule,
    NgHttpLoaderModule.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: 'fr',
      extend: true,
      loader: {
        provide: TranslateLoader,
        useFactory: (HttpLoaderFactory),
        deps: [HttpClient]
      }
    }),
    BreadcrumbModule,
    FontAwesomeModule,
    SharedModule,
    AvisDePubModule,
    MatTableModule,
    CreerModule,
    MatStepperModule,
    AdministrationModule,
    ToastrModule.forRoot({
      toastComponent: null
    }),
    OAuthModule.forRoot(),
    PreferencesModule
  ],
  providers: [
    { provide: ErrorHandler, useClass: ErrorHandlerService, },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
    { provide: LOCALE_ID, useValue: 'fr'},
    Title
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faArrowRight, faArrowDown);
  }
}
